/**
 * not-found-denied — approved copy, generated from the design.
 *
 * GENERATED. Do not hand-edit and do not paraphrase: every string here was
 * signed off by the client. A user-visible string typed into a component is a
 * finding, not a style preference.
 *
 * To change wording, change the design and re-run that stage. To change it for
 * THIS project only — a different city, a real address in place of a
 * placeholder — add a declared override, so it survives the next build run
 * instead of being reverted by it.
 *
 * Grouped by state. The empty and error wordings are the ones that get invented
 * at build time, because nobody paraphrases a heading they can see.
 */

export const copy = {
	default: {
		stateLabel: "State — Default",
		appTopbar:
			"Ramu followed a WhatsApp deep link to query #4182, which is not on his account. The screen never says which of the two reasons applies, shows no field of the record, and confirms the attempt was logged.",
		logo: "Swamithra — home",
		avatar: "Swamithra Notice assistance",
		who: "RP",
		whoMeta: "Ramu Prasad",
		/* aria-label */
		iconBtn: "Switch to dark theme",
		/* aria-label */
		sidenav: "Main",
		sidenavHeading: "Individual taxpayer",
		navlink: "Your account",
		sidenavFoot: "Home My queries Vetting Profile",
		mainInner: "Signed in until 7 Aug. We ask for an OTP again after five quiet days.",
		deadendTitle: "Query #4182",
		deadendLede: "This query isn’t on your account",
		facts: "Nothing here is yours to open, so we can’t show it. Either the reference doesn’t exist or it belongs to another taxpayer. If a colleague sent you the link, ask them to share the expert’s answer directly — a query can only be opened by the account that raised it.",
		num: "You asked for",
		facts2: "Signed in as",
		facts3: "Ramu Prasad · +91 98•••• ••10",
		num2: "At",
		facts4: "2 Aug 2026, 14:32 IST",
		num3: "Support reference",
		btn: "SWM-7F3C21",
		h3: "Go to my queries Back to home Ask an expert instead",
		hint: "Looking for something you raised?",
		field: "Type the reference from your WhatsApp message. We search only the queries and vetting requests on your own account.",
		/* placeholder */
		input: "#4182 or #V12",
		/* sample */
		fieldRow: "Query or vetting reference",
		btn2: "Find my record",
		fieldHelp: "Queries look like #4182. Vetting requests look like #V12.",
		why: "Why does it say this instead of “not found”?",
		why2: "We show the same message whether a reference is missing or belongs to someone else. If the two differed, anyone could try references one after another and learn which ones exist. This attempt has been written to our access log with the time and your account — you don’t need to report it.",
		h32: "Signed out a moment ago? Verify your number again and we’ll take you to wherever you were heading.",
		variants: "The same dead-end, two other causes",
		variantGrid:
			"Identical component, different copy and mark. The role variants appear inside the expert panel chrome, where the rail lists Queries, Vetting, Reporting and Experts.",
		variant: "Expert management is for Super Admins",
		actions:
			"Your panel account is set up as an Expert, so adding, deactivating and reactivating experts sits outside it. Ask your Super Admin if an account needs changing. Nothing about this page was loaded.",
		h4: "Back to the query queue Open vetting queue",
		variant2: "That link opens the expert panel",
		actions2:
			"You’re signed in to the taxpayer app, and panel screens can’t be opened from here. If you also hold a panel account, sign in to it separately — the two sessions stay apart on purpose.",
		btn3: "Back to home Go to expert sign-in",
		phone: "Mobile arrangement, 375px — bottom tab bar, edge-to-edge card, stacked facts and full-width actions.",
		avatar2: "Swamithra",
		facts5: "Either the reference doesn’t exist or it belongs to another taxpayer. If someone sent you this link, ask them to share the expert’s answer instead.",
		field2: "We search only the records on your own account.",
		/* sample */
		btn4: "Find my record",
		why3: "We show one message for both cases so nobody can use this page to discover which references exist. The attempt is already in our access log.",
		tab: "Home Queries Vetting Profile",
	},
	empty: {
		stateLabel: "State — Empty",
		appTopbar:
			"The dead-end itself is never “empty” — it always has a message. Both empty cases belong to the reference lookup underneath it: a brand-new account with nothing to look up, and a lookup that matched nothing.",
		avatar: "Swamithra Notice assistance",
		who: "RP",
		whoMeta: "Ramu Prasad",
		/* aria-label */
		iconBtn: "Switch to dark theme",
		/* aria-label */
		sidenav: "Main",
		sidenavHeading: "Individual taxpayer",
		navlink: "Your account",
		mainInner: "Home My queries Vetting Profile",
		deadendTitle: "Query #4182",
		deadendLede: "This query isn’t on your account",
		lookup: "Either the reference doesn’t exist or it belongs to another taxpayer. Nothing from the record has been loaded, and the attempt is in our access log.",
		hint: "Nothing to look up yet",
		empty: "First-run: the account has no queries and no vetting requests, so the reference field is replaced rather than left to fail.",
		empty2: "You haven’t raised anything yet",
		actions:
			"Your queries and vetting requests will be listed here with their reference numbers once you send your first one. Most people start by photographing the notice they received.",
		btn: "Ask an expert Get a draft vetted",
		hint2: "Reference lookup — no match",
		field: "No-results: the account has records, but none matching what was typed.",
		/* sample */
		fieldRow: "Query or vetting reference",
		h4: "Find my record",
		empty3: "Nothing on your account matches #9001",
		actions2:
			"Your six queries and two vetting requests all carry different references. Check the number in your WhatsApp message, or browse the full list instead.",
		btn2: "Browse my queries Browse vetting requests",
	},
	error: {
		stateLabel: "State — Error",
		appTopbar:
			"Two errors live on this screen: the reference field rejecting what was typed, and the access check itself failing to reach the server. The second is not a dead-end — it is unknown — so it offers a retry and keeps what was typed.",
		avatar: "Swamithra Notice assistance",
		who: "RP",
		whoMeta: "Ramu Prasad",
		/* aria-label */
		iconBtn: "Switch to dark theme",
		/* aria-label */
		sidenav: "Main",
		sidenavHeading: "Individual taxpayer",
		navlink: "Your account",
		mainInner: "Home My queries Vetting Profile",
		alert: "We couldn’t check this query",
		actions:
			"The connection dropped before we could confirm whether #4182 is on your account, so we haven’t shown you anything either way. Your network may have changed — try again, and if it keeps failing, come back in a few minutes. Nothing you typed has been lost.",
		btn: "Try again",
		btn2: "Go to my queries",
		deadendTitle: "Query #4182",
		deadendLede: "We can’t confirm this one yet",
		lookup: "Access checks run on our servers, never in your browser, so we’d rather say nothing than guess. Retry above, or look the record up by its reference.",
		field: "Looking for something you raised?",
		/* sample */
		fieldRow: "Query or vetting reference",
		fieldError: "Find my record",
		fieldHelp:
			"That isn’t a reference. Enter the number from your WhatsApp message — #4182 for a query, or #V12 for a vetting request.",
		fieldHelp2: "To search by subject instead, open My queries and use the list.",
	},
	loading: {
		stateLabel: "State — Loading",
		appTopbar:
			"While the deep link is being resolved we don’t yet know whether this ends in the record or in the dead-end, so the skeleton is the shape both share: mark, heading, two lines of explanation, the four-row fact block and two actions. No spinner.",
		avatar: "Swamithra Notice assistance",
		/* aria-label */
		iconBtn: "Switch to dark theme",
		/* aria-label */
		sidenav: "Main",
		sidenavHeading: "RP",
		navlink: "Your account",
		mainInner: "Home My queries Vetting Profile",
		actions: "Checking whether query #4182 is on your account.",
		phone: "Loading at 375px — the rail is replaced by the tab bar, which stays usable while the panel resolves.",
		avatar2: "Swamithra",
		tab: "Home Queries Vetting Profile",
	},
	success: {
		stateLabel: "State — Success",
		appTopbar:
			"The only way out of this screen that resolves here rather than by navigating away: the reference lookup found a record the person does own. The result carries just enough to recognise it — reference, title, date, status — and one action.",
		avatar: "Swamithra Notice assistance",
		who: "RP",
		whoMeta: "Ramu Prasad",
		/* aria-label */
		iconBtn: "Switch to dark theme",
		/* aria-label */
		sidenav: "Main",
		sidenavHeading: "Individual taxpayer",
		navlink: "Your account",
		mainInner: "Home My queries Vetting Profile",
		alert: "Found it — vetting request #V12 is on your account",
		alert2: "“Draft reply to s.143(1)(a) intimation — AY 2025-26”, sent 28 July 2026. CA Priya Nair returned her feedback on 31 July.",
		btn: "Answered",
		btn2: "Open vetting request #V12 See all my vetting requests",
		alert3: "Query #4182 is still not yours to open",
		h3: "The link you followed pointed somewhere else. If it came from a colleague, ask them to forward the expert’s answer — links can’t be shared between accounts.",
		field: "Look up another reference",
		/* placeholder */
		input: "#4182 or #V12",
		/* sample */
		fieldRow: "Query or vetting reference",
		/* sample */
		btn3: "Find my record",
		phone: "Success at 375px — the result becomes a full-width block with the action beneath it, above the tab bar.",
		avatar2: "Swamithra",
		alert4: "Found it — #V12",
		alert5: "“Draft reply to s.143(1)(a) intimation — AY 2025-26”, sent 28 July 2026.",
		btn4: "Open vetting request #V12 See all vetting requests",
		tab: "Home Queries Vetting Profile",
	},
} as const
